import React, { Component } from "react";
import { withRouter, NavLink } from "react-router-dom";
import {
  BoxDanger,
  MnemoLoading,
  MSection,
  SupportoTecnicoLive,
  Title,
} from "components/misc";
import { dateHelper, lessonLiveService, learningService, networkErrorHelper } from "libs";
import { ROUTES } from "const";
import { Button, Icon } from "design-react-kit";

class CourseLessonLiveScheduleOffline extends Component {

  state = {
    loading: true,
    ladingError: false,
    rCode: "",
    course: {},
    userCourse: {},
    lessonsStage1: [],
    liveClassesStage1: null,
    lessonsStage2: [],
    liveClassesStage2: null,
  };

  componentDidMount() {
    const { rCode } = this.props.match.params;
    this.setState({ rCode: rCode });

    this.loadUserCourse(rCode);
  }

  loadUserCourse(rCode) {

    learningService
      .courseDashboard(rCode)
      .then(({ data }) => {

        const { course, userCourse } = data.payload;
        this.setState({ course, userCourse });

        this.loadRemoteStage1(course.id, rCode);

        // al momneto non c'è una rprima e una seconda parte
        //this.loadRemoteStage2(course.id, rCode);
      })
      .catch(error => {

        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        }
      });
  }

  loadRemoteStage1(courseId, rCode) {
    lessonLiveService
      .MyScheduleStageOffline(courseId, 1, rCode)
      .then(({ data }) => {
        this.setState({
          loading: false,
          lessonsStage1: data.payload.lessonLiveSchedules,
          liveClassesStage1: data.payload.lessonLiveClass,
        });
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        }

        this.setState({
          loading: false,
          ladingError: true,
        });
      });
  }

  loadRemoteStage2(courseId, rCode) {
    lessonLiveService
      .MyScheduleStageOffline(courseId, 2)
      .then(({ data }) => {
        this.setState({
          loading: false,
          lessonsStage2: data.payload.lessonLiveSchedules,
          liveClassesStage2: data.payload.lessonLiveClass,
        });
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        }

        this.setState({
          loading: false,
          ladingError: true,
        });
      });
  }

  goDetail = (idLessonLive) => {
    const { rCode } = this.state;
    window.location = `${ROUTES.COURSE_LESSONLIVE_DETAIL}/${rCode}/${idLessonLive}`;
  };

  openMeet = (link) => {
    window.location = link;
  };

  renderStage(lessonsStage, stage, showTitle = true) {

    const label = (stage === 1) ? "Prima" : "Seconda";

    return (<MSection className="m-2">
      {showTitle && <h4> {label} fase del percorso</h4>}
      {lessonsStage.length > 0 ? (
        <>
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col">Data</th>
                <th scope="col">CFU</th>
                <th scope="col">SSD</th>
                <th scope="col">Insegnamento</th>
                <th scope="col">Ora Inizio</th>
                <th scope="col">Docente</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {lessonsStage.map((lesson, i) => (
                <tr key={i}>
                  <td>{dateHelper.toITDate(lesson.date)}</td>
                  <td>{lesson.cfu}</td>
                  <td>{lesson.ssd}</td>
                  <td>{lesson.subject}</td>
                  <td>{dateHelper.toShortTime(lesson.hourStart)}</td>
                  <td>{lesson.teacher}</td>
                  <td>
                    <Button
                      id="radio"
                      color="primary bg-dark m-1"
                      onClick={(e) => {
                        this.goDetail(lesson.id);
                      }}>
                      Dettaglio
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      ) : (
        <p>
          Il Calendario delle lezioni successive sarà disponibile prossimamente.
        </p>
      )}
    </MSection>)
  }

  render() {
    const {
      loading,
      loadingError,
      lessonsStage1,
      rCode,
      userCourse,
    } = this.state;

    if (loading) return <MnemoLoading></MnemoLoading>;
    if (loadingError)
      return (
        <BoxDanger className="m-5">
          Si è verificato un errore durante l'elaborazione della richiesta. <SupportoTecnicoLive courseCode={userCourse.courseCode}  />
        </BoxDanger>
      );

    return (
      <>
        <NavLink
          to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`}
          className="mx-5 btn btn-outline-primary float-right">
          <Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO
        </NavLink>
        <Title>Attività formative in presenza</Title>
        {this.renderStage(lessonsStage1, 1, false)}

        <SupportoTecnicoLive courseCode={userCourse.courseCode} />.
      </>
    );
  }
}

export default withRouter(CourseLessonLiveScheduleOffline);
